<div class="search-bar-container" [style.width]="width">
    <p-inputGroup class="search-bar">
        <p-inputGroupAddon>
            <i class="pi pi-search text-arena-orange"></i>
        </p-inputGroupAddon>
        <input pInputText type="text" class="w-full" [placeholder]="placeholder" [value]="value"
            (input)="onInputChange($event)" [style]="{outline: 'none'}" [disabled]="disabled" />
    </p-inputGroup>
</div>